<template>
  <div class="home is-light-mode">
    <div class="page-header">
      <h1 class="page-title">Agenda</h1>
      <p class="page-subtitle">Atendimentos e reservas</p>
    </div>
    <AppointmentFilters
      :status-list="statusList"
      :selected-status="selectedStatus"
      :client-list="allClients"
      :selected-client="selectedClient"
      :lash-list="allLashes"
      :selected-lash="selectedLash"
      :user-is-admin="canReadAllAppointments"
      @update:selected-status="selectedStatus = $event"
      @update:selected-client="selectedClient = $event"
      @update:selected-lash="selectedLash = $event"
    />
    <Qalendar
      :events="events"
      :config="config"
      @edit-event="handleEditClick"
      @delete-event="openDeleteConfirm"
      @datetime-was-clicked="handleAddClick"
      @date-was-clicked="dateWasClicked"
      @updated-period="onPeriodUpdated"
    />
    <section v-if="pendingRequests.length" class="home__requests">
      <h2 class="page-title home__requests-title">Solicitações pendentes</h2>
      <div class="card-list">
        <article
          v-for="req in pendingRequests"
          :key="req.id"
          class="card card--with-icon card--request"
        >
          <div class="card-icon-wrap">
            <i class="material-icons">schedule</i>
          </div>
          <div class="card-content">
            <h3 class="card-title card-primary">
              {{ req.clientName || 'Sem nome' }}
            </h3>
            <p class="card-secondary card-meta">
              <i class="material-icons card-meta-icon">schedule</i>
              {{ formatRequestDate(req.date) }}
            </p>
            <p class="card-meta">{{ serviceNames(req.services) }}</p>
          </div>
          
          <div class="card-actions">
            <button
              type="button"
              class="btn-icon"
              aria-label="Editar"
              @click="handleEditClick('request-' + req.id)"
            >
              <i class="material-icons">edit</i>
            </button>
            <button
              type="button"
              class="btn-icon btn-icon-danger"
              aria-label="Excluir"
              @click="openDeleteConfirm('request-' + req.id)"
            >
              <i class="material-icons">delete_outline</i>
            </button>
          </div>
        </article>
      </div>
    </section>
    <AppointmentList
      :appointments="allAppointments"
      :client-name="clientName"
      :service-names="serviceNames"
      @edit="handleEditClick"
      @delete="openDeleteConfirm"
    />
    <ConfirmDialog
      v-model="showDeleteConfirm"
      title="Excluir atendimento"
      :message="deleteConfirmMessage"
      confirm-label="Excluir"
      :confirm-loading="deleteLoading"
      :show-checkbox="deleteShowRevertCheckbox"
      checkbox-label="Reverter insumos no estoque"
      :checkbox-default="true"
      @confirm="doDeleteAppointment"
    />
    <AppointmentModal
      v-model="showModal"
      :saving="saveLoading"
      :selected-id="selectedId"
      :start-date="startDate"
      :end-date="endDate"
      :client="client"
      :selected-service="selectedService"
      :selected-services="selectedServices"
      :paid="paid"
      :payment-method="paymentMethod"
      :all-payment-methods="allPaymentMethods"
      :default-fee-percent="defaultFeePercent"
      :comments="comments"
      :lash="lash"
      :all-clients="allClients"
      :all-services="filteredServices"
      :all-lashes="allLashes"
      :user-is-admin="canReadAllAppointments"
      :total="total"
      :service-name="serviceName"
      :is-recurring="isRecurring"
      :recurrence-frequency="recurrenceFrequency"
      :recurrence-end-type="recurrenceEndType"
      :recurrence-end-date="recurrenceEndDate"
      :recurrence-count="recurrenceCount"
      @update:start-date="startDate = $event"
      @update:end-date="endDate = $event"
      @update:client="client = $event"
      @update:selected-service="selectedService = $event"
      @update:paid="paid = $event"
      @update:payment-method="paymentMethod = $event"
      @update:comments="comments = $event"
      @update:lash="lash = $event"
      @update:is-recurring="isRecurring = $event"
      @update:recurrence-frequency="recurrenceFrequency = $event"
      @update:recurrence-end-type="recurrenceEndType = $event"
      @update:recurrence-end-date="recurrenceEndDate = $event"
      @update:recurrence-count="recurrenceCount = $event"
      @add-service="handleAddServiceClick"
      @delete-service="handleDeleteServiceClick"
      @save="save"
      @realize="openCloseWizard"
      :appointment-paid="isCurrentAppointmentPaid"
      :inventory-applied="currentInventoryApplied"
      :supply-usage="currentSupplyUsage"
      :container-events="currentContainerEvents"
      :supplies-skipped="currentSuppliesSkipped"
      :supply-name-resolver="resolveSupplyName"
      :can-manage-supplies="canManageAppointmentSupplies"
      :show-edit-supplies="showEditSuppliesButton"
      :show-retry-inventory="showRetryInventoryButton"
      :supply-action-loading="supplyActionLoading"
      @edit-supplies="openEditSuppliesWizard"
      @retry-inventory="handleRetryInventory"
    />
    <CloseAppointmentWizard
      v-model="showCloseWizard"
      :client-id="client?.id || ''"
      :selected-services="closeWizardServices"
      :total="total"
      :all-payment-methods="allPaymentMethods"
      :default-fee-percent="defaultFeePercent"
      :initial-paid="closeWizardInitialPaid"
      :initial-payment-method="closeWizardPaymentMethod"
      :saving="closeWizardLoading"
      @confirm="handleCloseWizardConfirm"
      @cancel="showCloseWizard = false"
    />
    <CloseAppointmentWizard
      v-model="showEditSuppliesWizard"
      supplies-only
      :client-id="client?.id || ''"
      :selected-services="closeWizardServices"
      :initial-supply-usage="currentSupplyUsage"
      :initial-container-events="currentContainerEvents"
      :inventory-already-applied="currentInventoryApplied"
      :saving="editSuppliesLoading"
      @confirm="handleEditSuppliesConfirm"
      @cancel="showEditSuppliesWizard = false"
    />
    <ConvertRequestModal
      v-model="showConvertModal"
      :request="selectedRequestId ? (appointmentRequestStore.requests[selectedRequestId] || null) : null"
      :start-date="convertStartDate"
      :end-date="convertEndDate"
      :client-name="convertClientName"
      :client-phone="convertClientPhone"
      :existing-client="convertExistingClient"
      :selected-services="convertSelectedServices"
      :paid="convertPaid"
      :payment-method="convertPaymentMethod"
      :all-payment-methods="allPaymentMethods"
      :default-fee-percent="defaultFeePercent"
      :total="convertTotal"
      :comments="convertComments"
      :lash="convertLash"
      :all-services="convertFilteredServices"
      :all-lashes="allLashes"
      :user-is-admin="canReadAllAppointments"
      :service-name="serviceName"
      :saving="convertSaveLoading"
      @update:clientName="convertClientName = $event"
      @update:clientPhone="convertClientPhone = $event"
      @update:startDate="convertStartDate = $event"
      @update:endDate="convertEndDate = $event"
      @update:selectedServices="convertSelectedServices = $event"
      @update:paid="convertPaid = $event"
      @update:payment-method="convertPaymentMethod = $event"
      @update:comments="convertComments = $event"
      @update:lash="convertLash = $event"
      @add-service="handleAddServiceFromConvert($event)"
      @delete-service="handleDeleteServiceFromConvert"
      @save="saveConvert"
    />
    <button type="button" class="btn-fab" @click="handleAddClick" aria-label="Novo atendimento">
      <i class="material-icons">add</i>
    </button>
  </div>
</template>

<script>
import { doc, collection, deleteDoc, setDoc, addDoc, writeBatch } from "firebase/firestore";
import { firestore } from '@/firebase';
import { ref, computed, watch } from 'vue';
import { useUserStore } from '@/stores/user';
import { useToast } from '@/composables/useToast';
import { useClientStore } from '@/stores/client';
import { useServiceStore } from '@/stores/service';
import { useAppointmentStore } from '@/stores/appointment';
import { useAppointmentRequestStore } from '@/stores/appointmentRequest';
import { usePaymentMethodStore } from '@/stores/paymentMethod';
import 'qalendar/dist/style.css';
import { Qalendar } from "qalendar";

import AppointmentFilters from '@/components/AppointmentFilters.vue';
import AppointmentList from '@/components/AppointmentList.vue';
import AppointmentModal from '@/components/AppointmentModal.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import ConvertRequestModal from '@/components/ConvertRequestModal.vue';
import CloseAppointmentWizard from '@/components/CloseAppointmentWizard.vue';
import { useSupplyStore } from '@/stores/supply';
import { isPaidValue } from '@/utils/supplyLabels';
import { hasInventoryStockImpact } from '@/utils/inventoryActivity';
import { appointmentNeedsSuppliesStep } from '@/utils/supplyConfig';
import {
  revertAppointmentInventory,
  retryAppointmentInventory,
  updateAppointmentSupplies,
} from '@/utils/appointmentInventory';
import { toQalendarDateString, toIsoString, computeRecurrenceOccurrences } from '@/utils/dateUtils';
import { normalizeToRaw } from '@/utils/phoneUtils';

export default {
  components: {
    Qalendar,
    AppointmentFilters,
    AppointmentList,
    AppointmentModal,
    ConfirmDialog,
    ConvertRequestModal,
    CloseAppointmentWizard,
  },
  setup() {
    let selectedDateText = '';
    const dateWasClicked = (e) => {
      selectedDateText = e + ' 08:00';
    };

    const onPeriodUpdated = (period) => {
      if (!period?.start) return;
      const d = new Date(period.start);
      d.setDate(d.getDate() + 15);
      appointmentStore.registerMonthSnapshot(d);
    };

    const hourInMilliseconds = 60 * 60 * 1000;
    const userStore = useUserStore();
    const clientStore = useClientStore();
    const serviceStore = useServiceStore();
    const appointmentStore = useAppointmentStore();
    const appointmentRequestStore = useAppointmentRequestStore();
    const paymentMethodStore = usePaymentMethodStore();
    const supplyStore = useSupplyStore();

    function resolvePaymentMethodForEdit(appointment) {
      if (appointment?.paymentMethodId && paymentMethodStore.paymentMethods[appointment.paymentMethodId]) {
        return { ...paymentMethodStore.paymentMethods[appointment.paymentMethodId] };
      }
      const defaultMethod = paymentMethodStore.defaultPaymentMethod;
      return defaultMethod ? { ...defaultMethod } : null;
    }

    function buildPaymentMethodFields(selectedMethod) {
      const method = selectedMethod || paymentMethodStore.defaultPaymentMethod;
      if (!method) return {};
      return {
        paymentMethodId: method.id,
        paymentMethodFeePercent: Math.round((Number(method.feePercent) || 0) * 100) / 100,
      };
    }

    const getColorScheme = (lash) => {
      if (userStore.hasPermission('appointments:manage') && lash in userStore.users) {
        return lash;
      }
      return 'appointment';
    };

    const getColorSchemes = () => {
      const colorSchemes = {
        appointment: {
          color: '#000',
          backgroundColor: '#ECD2D2',
        },
        paidAppointment: {
          color: '#000',
          backgroundColor: '#DBC1C1',
        },
        request: {
          color: '#000',
          backgroundColor: '#B8D4E3',
        },
      };
      for (const usr of Object.entries(userStore.users)) {
        colorSchemes[usr[0]] = {
          color: '#000',
          backgroundColor: usr[1].color || '#ECD2D2',
        };
      }
      return colorSchemes;
    };

    const clientName = (id) => {
      if (id in clientStore.clients)
        return clientStore.clients[id].name;
      return 'Não encontrado.';
    };

    const serviceName = (id) => {
      if (id in serviceStore.services) {
        return serviceStore.services[id].name;
      }
      return 'Não encontrado';
    };

    const lashName = (id) => {
      if (id in userStore.users) {
        return userStore.users[id].name;
      }
      return 'Rafa';
    };

    const serviceNames = (appointmentServices) => {
      return appointmentServices.map(service => {
        if ((service.service ?? service.serviceId) in serviceStore.services) {
          return serviceStore.services[service.service ?? service.serviceId].name;
        }
        return 'Não encontrado.';
      }).reduce((prevVal, elem) => prevVal ? prevVal + ', ' + elem : elem, '');
    };

    const allAppointments = computed(() => {
      let appoint = [];
      for (const value of Object.entries(appointmentStore.appointments)) {
        if (selectedStatus.value === 'Todos' ||
          ((selectedStatus.value === 'Abertos' || !selectedStatus.value) && value[1].paid === '') ||
          (selectedStatus.value === 'Realizados' && value[1].paid !== '')) {
          if (!selectedClient.value || selectedClient.value.id === value[1].client) {
            if (userStore.hasPermission('appointments:manage') || userStore.user.uid === value[1].lash) {
              if (!selectedLash.value || selectedLash.value.id == value[1].lash) {
                appoint.push({ ...value[1] });
              }
            }
          }
        }
      }
      return appoint.sort((a, b) => a.date - b.date);
    });

    const events = computed(() => {
      const appointmentEvents = allAppointments.value.map(a => {
        const paidPrefix = a.paid !== '' ? 'PAGO - ' : '';
        const confirmedPrefix = a.clientConfirmedAt ? 'CONFIRMADO - ' : '';
        const canceledPrefix = a.clientCanceledAt ? 'CANCELADO - ' : '';
        return {
          title: paidPrefix + confirmedPrefix + canceledPrefix + clientName(a.client),
          with: 'Lash ' + lashName(a.lash),
          time: {
            start: toQalendarDateString(new Date(a.date)),
            end: toQalendarDateString(new Date(a.endDate ? a.endDate : (a.date + 2 * hourInMilliseconds))),
          },
          isEditable: true,
          id: a.id,
          description: serviceNames(a.services) + (a.comments ? '<br>' + a.comments : ''),
          colorScheme: getColorScheme(a.lash),
          disableDnD: ['month', 'week', 'day'],
          disableResize: ['week', 'day'],
        };
      });
      const requestEvents = appointmentRequestStore.pendingRequests.map(req => ({
        title: 'Solicitação – ' + (req.clientName || 'Sem nome'),
        with: 'Lash ' + lashName(req.lash),
        time: {
          start: toQalendarDateString(new Date(req.date)),
          end: toQalendarDateString(new Date(req.endDate || req.date + hourInMilliseconds)),
        },
        isEditable: true,
        id: 'request-' + req.id,
        description: serviceNames(req.services) + (req.notes ? '<br>' + req.notes : ''),
        colorScheme: 'request',
        disableDnD: ['month', 'week', 'day'],
        disableResize: ['week', 'day'],
      }));
      return [...appointmentEvents, ...requestEvents];
    });

    const config = computed(() => ({
      defaultMode: 'month',
      dayBoundaries: {
        start: 5,
        end: 23,
      },
      showCurrentTime: false,
      month: {
        showTrailingAndLeadingDates: false,
      },
      week: {
        startsOn: 'sunday',
      },
      style: {
        colorSchemes: getColorSchemes(),
      },
      locale: 'pt-BR',
    }));

    const showModal = ref(false);
    const selectedId = ref(null);
    const startDate = ref('');
    const endDate = ref('');
    const client = ref('');
    const selectedService = ref('');
    const selectedServices = ref([]);
    const paid = ref('');
    const paymentMethod = ref(null);
    const statusList = ref(['Todos', 'Abertos', 'Realizados']);
    const selectedStatus = ref('Abertos');
    const selectedClient = ref(null);
    const selectedLash = ref(null);
    const comments = ref('');
    const lash = ref('');
    const isRecurring = ref(false);
    const recurrenceFrequency = ref('weekly');
    const recurrenceEndType = ref('until');
    const recurrenceEndDate = ref('');
    const recurrenceCount = ref(2);
    const showConvertModal = ref(false);
    const selectedRequestId = ref(null);
    const convertClientName = ref('');
    const convertClientPhone = ref('');
    const convertStartDate = ref('');
    const convertEndDate = ref('');
    const convertSelectedServices = ref([]);
    const convertComments = ref('');
    const convertPaid = ref(null);
    const convertPaymentMethod = ref(null);
    const convertLash = ref('');
    const convertSaveLoading = ref(false);
    const showCloseWizard = ref(false);
    const showEditSuppliesWizard = ref(false);
    const closeWizardLoading = ref(false);
    const editSuppliesLoading = ref(false);
    const supplyActionLoading = ref(false);

    const isCurrentAppointmentPaid = computed(() => {
      if (!selectedId.value) return false;
      const ap = appointmentStore.appointments[selectedId.value];
      return ap ? isPaidValue(ap.paid) : false;
    });

    const currentInventoryApplied = computed(() => {
      if (!selectedId.value) return false;
      const ap = appointmentStore.appointments[selectedId.value];
      return !!ap?.inventoryApplied;
    });

    const currentSupplyUsage = computed(() => {
      if (!selectedId.value) return [];
      const ap = appointmentStore.appointments[selectedId.value];
      return Array.isArray(ap?.supplyUsage) ? ap.supplyUsage : [];
    });

    const currentContainerEvents = computed(() => {
      if (!selectedId.value) return [];
      const ap = appointmentStore.appointments[selectedId.value];
      return Array.isArray(ap?.containerEvents) ? ap.containerEvents : [];
    });

    const currentSuppliesSkipped = computed(() => {
      if (!selectedId.value) return false;
      const ap = appointmentStore.appointments[selectedId.value];
      return !!ap?.suppliesSkipped;
    });

    const closeWizardServices = computed(() => {
      if (showCloseWizard.value || showEditSuppliesWizard.value) {
        return selectedServices.value;
      }
      return [];
    });

    const closeWizardInitialPaid = computed(() => {
      return total.value;
    });

    const closeWizardPaymentMethod = computed(() => {
      return paymentMethod.value || paymentMethodStore.defaultPaymentMethod;
    });

    const canManageAppointmentSupplies = computed(() => {
      if (!selectedId.value) return false;
      const ap = appointmentStore.appointments[selectedId.value];
      if (!ap) return false;
      return userStore.hasPermission('appointments:manage') || ap.lash === userStore.user?.uid;
    });

    const showEditSuppliesButton = computed(() => {
      if (!isCurrentAppointmentPaid.value || !canManageAppointmentSupplies.value) return false;
      if (currentSuppliesSkipped.value) return false;
      const ap = selectedId.value ? appointmentStore.appointments[selectedId.value] : null;
      if (!ap) return false;
      if (hasInventoryStockImpact(ap)) return true;
      return appointmentNeedsSuppliesStep(selectedServices.value, serviceStore.services);
    });

    const showRetryInventoryButton = computed(() => {
      if (!isCurrentAppointmentPaid.value || !canManageAppointmentSupplies.value) return false;
      if (currentInventoryApplied.value || currentSuppliesSkipped.value) return false;
      const ap = selectedId.value ? appointmentStore.appointments[selectedId.value] : null;
      return hasInventoryStockImpact(ap);
    });

    const deleteShowRevertCheckbox = computed(() => {
      const docId = deleteTargetId.value;
      if (!docId || String(docId).startsWith('request-')) return false;
      const ap = appointmentStore.appointments[docId];
      return !!ap?.inventoryApplied && hasInventoryStockImpact(ap) && !ap?.suppliesSkipped;
    });

    const resolveSupplyName = (supplyId) => {
      const supply = supplyStore.supplies[supplyId];
      return supply?.name || supplyId;
    };

    const total = computed(() => {
      return (selectedServices.value || []).reduce(
        (sum, s) => sum + (Number(s.price) || 0),
        0
      );
    });

    const openCloseWizard = () => {
      showCloseWizard.value = true;
    };

    const openEditSuppliesWizard = () => {
      if (!showEditSuppliesButton.value) return;
      showEditSuppliesWizard.value = true;
    };

    const handleRetryInventory = async () => {
      if (!selectedId.value || !showRetryInventoryButton.value) return;
      supplyActionLoading.value = true;
      try {
        await retryAppointmentInventory(selectedId.value);
        showToast('Insumos registrados no estoque.', 'success');
      } catch (err) {
        showToast(err.message || 'Não foi possível registrar os insumos.', 'error');
      } finally {
        supplyActionLoading.value = false;
      }
    };

    const handleEditSuppliesConfirm = async (payload) => {
      if (!selectedId.value) return;
      editSuppliesLoading.value = true;
      try {
        await updateAppointmentSupplies(
          selectedId.value,
          payload.supplyUsage || [],
          payload.containerEvents || [],
        );
        showEditSuppliesWizard.value = false;
        showToast('Insumos atualizados.', 'success');
      } catch (err) {
        showToast(err.message || 'Não foi possível atualizar os insumos.', 'error');
      } finally {
        editSuppliesLoading.value = false;
      }
    };

    const handleAddClick = (e) => {
      let dateText = '';
      if (typeof e === 'string') {
        dateText = e;
      } else if (selectedDateText) {
        dateText = selectedDateText;
      } else {
        let currentDate = new Date();
        currentDate.setHours(8, 0, 0, 0);
        dateText = toQalendarDateString(currentDate);
      }
      selectedId.value = null;
      const eventDate = new Date(dateText);
      eventDate.setMinutes(0);
      eventDate.setSeconds(0);
      eventDate.setMilliseconds(0);
      startDate.value = toIsoString(eventDate);
      endDate.value = toIsoString(new Date(eventDate.getTime() + 2 * 3600000));
      client.value = '';
      selectedServices.value = [];
      paid.value = null;
      paymentMethod.value = paymentMethodStore.defaultPaymentMethod
        ? { ...paymentMethodStore.defaultPaymentMethod }
        : null;
      comments.value = '';
      lash.value = { ...userStore.users[userStore.user.uid] };
      isRecurring.value = false;
      recurrenceFrequency.value = 'weekly';
      recurrenceEndType.value = 'until';
      recurrenceEndDate.value = '';
      recurrenceCount.value = 2;
      showModal.value = true;
    };

    const handleAddServiceClick = () => {
      selectedServices.value.push({
        service: selectedService.value.id,
        price: selectedService.value.price,
      });
      selectedService.value = '';
    };

    const handleEditClick = (id, e) => {
      if (e) {
        e.stopPropagation();
      }
      const rawId = id?.id ?? id;
      if (String(rawId).startsWith('request-')) {
        const requestId = String(rawId).replace(/^request-/, '');
        const req = appointmentRequestStore.requests[requestId];
        if (req) {
          selectedRequestId.value = requestId;
          convertClientName.value = req.clientName || '';
          convertClientPhone.value = req.clientPhone || '';
          convertStartDate.value = toIsoString(new Date(req.date));
          convertEndDate.value = req.endDate ? toIsoString(new Date(req.endDate)) : toIsoString(new Date(req.date + 2 * 3600000));
          convertSelectedServices.value = (req.services || []).map((s) => ({
            service: s.serviceId ?? s.service,
            price: Number(s.price) ?? 0,
          }));
          convertComments.value = req.notes || '';
          convertPaid.value = null;
          convertPaymentMethod.value = paymentMethodStore.defaultPaymentMethod
            ? { ...paymentMethodStore.defaultPaymentMethod }
            : null;
          if (req.lash && userStore.users[req.lash]) {
            convertLash.value = { ...userStore.users[req.lash] };
          } else {
            convertLash.value = { ...userStore.users[userStore.user.uid] };
          }
          showConvertModal.value = true;
        }
        return;
      }
      selectedId.value = rawId;
      const ap = appointmentStore.appointments[rawId];
      startDate.value = toIsoString(new Date(ap.date));
      endDate.value = ap.endDate ? toIsoString(new Date(ap.endDate)) : toIsoString(new Date(ap.date + 2 * 3600000));
      client.value = { ...clientStore.clients[ap.client] };
      selectedServices.value = ap.services.map(s => ({ price: s.price, service: s.service }));
      paid.value = ap.paid !== '' && ap.paid != null ? Number(ap.paid) : null;
      paymentMethod.value = resolvePaymentMethodForEdit(ap);
      comments.value = ap.comments ?? '';
      if (ap.lash) {
        lash.value = { ...userStore.users[ap.lash] };
      } else {
        lash.value = { ...userStore.users[userStore.user.uid] };
      }
      showModal.value = true;
    };

    const showDeleteConfirm = ref(false);
    const deleteTargetId = ref(null);
    const saveLoading = ref(false);
    const deleteLoading = ref(false);
    const { show: showToast } = useToast();

    const openDeleteConfirm = (id) => {
      deleteTargetId.value = id?.id ?? id;
      showDeleteConfirm.value = true;
    };

    const deleteConfirmMessage = computed(() => {
      const docId = deleteTargetId.value;
      if (!docId || String(docId).startsWith('request-')) {
        return 'Tem certeza que deseja excluir este atendimento? Esta ação não pode ser desfeita.';
      }
      const ap = appointmentStore.appointments[docId];
      if (deleteShowRevertCheckbox.value) {
        return 'Este atendimento alterou o estoque. Você pode reverter os insumos antes de excluir. Deseja continuar?';
      }
      if (hasInventoryStockImpact(ap) && !ap?.inventoryApplied) {
        return 'Este atendimento tem insumos registrados que ainda não foram aplicados ao estoque. Deseja continuar?';
      }
      if (hasInventoryStockImpact(ap)) {
        return 'Este atendimento alterou o estoque. Excluir não reverte os insumos — ajuste manualmente em Estoque se necessário. Deseja continuar?';
      }
      return 'Tem certeza que deseja excluir este atendimento? Esta ação não pode ser desfeita.';
    });

    const doDeleteAppointment = async (options) => {
      if (!deleteTargetId.value) return;
      const isRequest = String(deleteTargetId.value).startsWith('request-');
      const docId = isRequest ? String(deleteTargetId.value).replace(/^request-/, '') : deleteTargetId.value;
      const revertInventory = !!options?.checkboxChecked;
      deleteLoading.value = true;
      try {
        if (isRequest) {
          await deleteDoc(doc(firestore, 'appointmentRequests', docId));
          showToast('Solicitação removida.', 'success');
        } else {
          if (revertInventory) {
            await revertAppointmentInventory(docId);
          }
          await deleteDoc(doc(firestore, 'appointments', docId));
          showToast('Atendimento excluído.', 'success');
        }
        deleteTargetId.value = null;
        showDeleteConfirm.value = false;
      } catch (err) {
        showToast('Não foi possível excluir. Tente novamente.', 'error');
      } finally {
        deleteLoading.value = false;
      }
    };

    const handleDeleteServiceClick = (id) => {
      selectedServices.value = selectedServices.value.filter(s => s.service !== id);
    };

    const handleAddServiceFromConvert = (service) => {
      if (service && service.id) {
        convertSelectedServices.value = [
          ...convertSelectedServices.value,
          { service: service.id, price: Number(service.price) ?? 0 },
        ];
      }
    };

    const handleDeleteServiceFromConvert = (id) => {
      convertSelectedServices.value = convertSelectedServices.value.filter(s => s.service !== id);
    };

    const saveConvert = async () => {
      if (!convertLash.value || !convertLash.value.id) {
        convertLash.value = { ...userStore.users[userStore.user.uid] };
      }
      convertSaveLoading.value = true;
      try {
        const phoneRaw = normalizeToRaw(convertClientPhone.value) || (convertClientPhone.value || '').trim();
        const existingByPhone = Object.entries(clientStore.clients).find(
          ([, c]) => (normalizeToRaw(c.phone) || (c.phone || '').trim()) === phoneRaw
        );
        let clientId;
        if (existingByPhone) {
          clientId = existingByPhone[0];
        } else {
          const client = await addDoc(collection(firestore, 'clients'), {
            name: convertClientName.value.trim(),
            phone: convertClientPhone.value.trim(),
          });
          clientId = client.id;
        }
        const docData = {
          date: new Date(convertStartDate.value).getTime(),
          client: clientId,
          services: convertSelectedServices.value.map((s) => ({ service: s.service, price: Number(s.price) ?? 0 })),
          paid: convertPaid.value !== null && convertPaid.value !== undefined ? convertPaid.value : '',
          comments: convertComments.value,
          endDate: new Date(convertEndDate.value).getTime(),
          lash: convertLash.value.id,
          ...buildPaymentMethodFields(convertPaymentMethod.value),
        };
        await addDoc(collection(firestore, 'appointments'), docData);
        if (selectedRequestId.value) {
          await deleteDoc(doc(firestore, 'appointmentRequests', selectedRequestId.value));
        }
        showConvertModal.value = false;
        selectedRequestId.value = null;
        showToast('Atendimento criado a partir da solicitação.', 'success');
      } catch (err) {
        showToast('Não foi possível criar o atendimento. Tente novamente.', 'error');
      } finally {
        convertSaveLoading.value = false;
      }
    };

    const save = async () => {
      if (!lash.value) {
        lash.value = { ...userStore.users[userStore.user.uid] };
      }
      saveLoading.value = true;
      try {
        const existingAp = selectedId.value
          ? appointmentStore.appointments[selectedId.value]
          : null;
        const alreadyPaid = existingAp && isPaidValue(existingAp.paid);
        const baseDocData = {
          client: client.value.id,
          services: selectedServices.value.map((s) => ({ service: s.service, price: Number(s.price) ?? 0 })),
          paid: alreadyPaid && paid.value !== null && paid.value !== undefined ? paid.value : '',
          comments: comments.value,
          endDate: new Date(endDate.value).getTime(),
          lash: lash.value.id,
          ...(alreadyPaid ? buildPaymentMethodFields(paymentMethod.value) : {}),
        };
        if (selectedId.value) {
          const docData = {
            ...baseDocData,
            date: new Date(startDate.value).getTime(),
          };
          await setDoc(doc(firestore, 'appointments', selectedId.value), docData, { merge: true });
          showModal.value = false;
          showToast('Atendimento alterado.', 'success');
          return;
        }
        const startMs = new Date(startDate.value).getTime();
        const endMs = new Date(endDate.value).getTime();
        if (isRecurring.value) {
          const endCondition =
            recurrenceEndType.value === 'count'
              ? { type: 'count', count: recurrenceCount.value }
              : {
                  type: 'until',
                  untilDateMs: recurrenceEndDate.value
                    ? new Date(recurrenceEndDate.value + 'T23:59:59').getTime()
                    : null,
                };
          const occurrences = computeRecurrenceOccurrences(
            startMs,
            endMs,
            recurrenceFrequency.value,
            endCondition
          );
          if (occurrences.length === 0) {
            showToast('Nenhuma ocorrência gerada. Verifique a data final ou o número de ocorrências.', 'error');
            return;
          }
          const recurrenceSeriesId = crypto.randomUUID();
          const col = collection(firestore, 'appointments');
          const batch = writeBatch(firestore);
          for (const occ of occurrences) {
            batch.set(doc(col), {
              ...baseDocData,
              date: occ.dateMs,
              endDate: occ.endDateMs,
              recurrenceSeriesId,
            });
          }
          await batch.commit();
          showModal.value = false;
          showToast(`${occurrences.length} atendimentos repetidos criados.`, 'success');
        } else {
          await addDoc(collection(firestore, 'appointments'), {
            ...baseDocData,
            date: startMs,
            endDate: endMs,
          });
          showModal.value = false;
          showToast('Atendimento salvo.', 'success');
        }
      } catch (err) {
        showToast('Não foi possível salvar. Tente novamente.', 'error');
      } finally {
        saveLoading.value = false;
      }
    };

    const handleCloseWizardConfirm = async (payload) => {
      if (!lash.value) {
        lash.value = { ...userStore.users[userStore.user.uid] };
      }
      closeWizardLoading.value = true;
      try {
        const baseDocData = {
          client: client.value.id,
          services: selectedServices.value.map((s) => ({ service: s.service, price: Number(s.price) ?? 0 })),
          paid: payload.paid !== null && payload.paid !== undefined ? payload.paid : '',
          comments: comments.value,
          endDate: new Date(endDate.value).getTime(),
          lash: lash.value.id,
          ...buildPaymentMethodFields(payload.paymentMethod),
          supplyUsage: payload.supplyUsage || [],
          containerEvents: payload.containerEvents || [],
          suppliesSkipped: !!payload.suppliesSkipped,
        };
        if (selectedId.value) {
          await setDoc(
            doc(firestore, 'appointments', selectedId.value),
            { ...baseDocData, date: new Date(startDate.value).getTime() },
            { merge: true }
          );
        } else {
          await addDoc(collection(firestore, 'appointments'), {
            ...baseDocData,
            date: new Date(startDate.value).getTime(),
          });
        }
        showCloseWizard.value = false;
        showModal.value = false;
        showToast('Atendimento realizado.', 'success');
      } catch (err) {
        showToast('Não foi possível realizar o atendimento. Tente novamente.', 'error');
      } finally {
        closeWizardLoading.value = false;
      }
    };

    const sortByName = (a, b) => {
      const nameA = a.name.toUpperCase();
      const nameB = b.name.toUpperCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    };

    const pendingRequests = computed(() => appointmentRequestStore.pendingRequests);

    const formatRequestDate = (dateMs) => {
      if (!dateMs) return '';
      return new Date(dateMs).toLocaleString('pt-BR').substring(0, 17);
    };

    watch(lash, (newLash) => {
      if (!newLash) return;
      const ids = newLash.serviceIds;
      if (!Array.isArray(ids) || ids.length === 0) return;
      const filtered = selectedServices.value.filter((sel) => ids.includes(sel.service));
      if (filtered.length !== selectedServices.value.length) {
        selectedServices.value = filtered;
      }
    });

    watch(convertLash, (newLash) => {
      if (!newLash) return;
      const ids = newLash.serviceIds;
      if (!Array.isArray(ids) || ids.length === 0) return;
      const filtered = convertSelectedServices.value.filter((sel) => ids.includes(sel.service));
      if (filtered.length !== convertSelectedServices.value.length) {
        convertSelectedServices.value = filtered;
      }
    });

    return {
      events,
      config,
      dateWasClicked,
      onPeriodUpdated,
      startDate,
      endDate,
      client,
      paid,
      paymentMethod,
      comments,
      clientName,
      selectedService,
      selectedServices,
      serviceName,
      serviceNames,
      lash,
      selectedId,
      statusList,
      selectedStatus,
      selectedClient,
      selectedLash,
      showModal,
      isRecurring,
      recurrenceFrequency,
      recurrenceEndType,
      recurrenceEndDate,
      recurrenceCount,
      save,
      handleAddClick,
      handleAddServiceClick,
      handleEditClick,
      openDeleteConfirm,
      doDeleteAppointment,
      handleDeleteServiceClick,
      showDeleteConfirm,
      deleteTargetId,
      deleteConfirmMessage,
      saveLoading,
      deleteLoading,
      allAppointments,
      allLashes: computed(() => {
        const las = [];
        for (const value of Object.entries(userStore.users)) {
          las.push({ ...value[1] });
        }
        return las.sort(sortByName);
      }),
      allClients: computed(() => {
        const cli = [];
        for (const value of Object.entries(clientStore.clients)) {
          cli.push({ ...value[1] });
        }
        return cli.sort(sortByName);
      }),
      allServices: computed(() => {
        const serv = [];
        for (const value of Object.entries(serviceStore.services)) {
          serv.push({ ...value[1] });
        }
        return serv.sort(sortByName);
      }),
      filteredServices: computed(() => {
        if (!lash.value || !lash.value.id) return [];
        const allServ = [];
        for (const value of Object.entries(serviceStore.services)) {
          allServ.push({ ...value[1] });
        }
        const sorted = allServ.sort(sortByName);
        const ids = lash.value.serviceIds;
        if (!Array.isArray(ids) || ids.length === 0) return sorted;
        return sorted.filter(s => ids.includes(s.id));
      }),
      convertFilteredServices: computed(() => {
        if (!convertLash.value || !convertLash.value.id) return [];
        const allServ = [];
        for (const value of Object.entries(serviceStore.services)) {
          allServ.push({ ...value[1] });
        }
        const sorted = allServ.sort(sortByName);
        const ids = convertLash.value.serviceIds;
        if (!Array.isArray(ids) || ids.length === 0) return sorted;
        return sorted.filter(s => ids.includes(s.id));
      }),
      total,
      convertTotal: computed(() =>
        convertSelectedServices.value.map((s) => Number(s.price) || 0).reduce((a, b) => a + b, 0),
      ),
      showCloseWizard,
      showEditSuppliesWizard,
      closeWizardLoading,
      editSuppliesLoading,
      supplyActionLoading,
      isCurrentAppointmentPaid,
      currentInventoryApplied,
      currentSupplyUsage,
      currentContainerEvents,
      currentSuppliesSkipped,
      closeWizardServices,
      closeWizardInitialPaid,
      closeWizardPaymentMethod,
      resolveSupplyName,
      openCloseWizard,
      openEditSuppliesWizard,
      handleRetryInventory,
      handleEditSuppliesConfirm,
      handleCloseWizardConfirm,
      canManageAppointmentSupplies,
      showEditSuppliesButton,
      showRetryInventoryButton,
      deleteShowRevertCheckbox,
      allPaymentMethods: computed(() => paymentMethodStore.allPaymentMethods),
      defaultFeePercent: computed(() => paymentMethodStore.defaultFeePercent),
      canReadAllAppointments: computed(() => userStore.hasPermission('appointments:manage')),
      convertExistingClient: computed(() => {
        const phoneRaw = normalizeToRaw(convertClientPhone.value) || (convertClientPhone.value || '').trim();
        if (!phoneRaw) return null;
        const found = Object.entries(clientStore.clients).find(
          ([, c]) => (normalizeToRaw(c.phone) || (c.phone || '').trim()) === phoneRaw
        );
        return found ? { id: found[0], name: found[1].name } : null;
      }),
      showConvertModal,
      selectedRequestId,
      convertClientName,
      convertClientPhone,
      convertStartDate,
      convertEndDate,
      convertSelectedServices,
      convertPaid,
      convertPaymentMethod,
      convertComments,
      convertLash,
      convertSaveLoading,
      pendingRequests,
      formatRequestDate,
      handleAddServiceFromConvert,
      handleDeleteServiceFromConvert,
      saveConvert,
      appointmentRequestStore,
    };
  },
};
</script>

<style scoped>
.home {
  padding: var(--space-md) 0;
}
.home__requests {
  margin-top: var(--space-xl);
}
.home__requests-title {
  margin-bottom: var(--space-md);
}
.card--request .card-icon-wrap {
  background: var(--color-accent-soft);
  color: var(--color-accent);
}
</style>

<style>
/* Qalendar theme – align with design system */
.calendar-root {
  background-color: var(--color-surface) !important;
  --qalendar-theme-color: var(--color-accent) !important;
  --qalendar-blue: var(--color-accent) !important;
  border-radius: var(--radius-md) !important;
  border: 1px solid var(--color-border) !important;
  overflow: hidden !important;
}

.calendar-root-wrapper .calendar-root {
  background-color: var(--color-surface) !important;
  color: var(--color-text) !important;
}

.calendar-root,
.date-picker-root {
  --qalendar-gray-quite-dark: var(--color-text-secondary) !important;
}

.date-picker__value-display,
.calendar-header__mode-picker .calendar-header__mode-value,
.calendar-header__mode-picker .calendar-header__mode-options,
.date-picker__week-picker {
  background-color: var(--color-surface) !important;
  border-color: var(--color-border) !important;
}

.calendar-header__mode-picker {
  border-color: var(--color-border) !important;
}

.calendar-month .calendar-month__week,
.calendar-month__weekday,
.day-timeline__hour {
  border-color: var(--color-border) !important;
}

.event-flyout {
  background-color: var(--color-surface) !important;
  border-color: var(--color-border) !important;
}

.event-flyout__menu-item {
  color: var(--color-text-secondary) !important;
}

.event-flyout__row svg {
  color: var(--color-text-muted) !important;
}

</style>
